import { Flex } from '@servicetitan/anvil2';
import { Fieldset, StateSelectField, TextField } from '@servicetitan/anvil2-react-hook-form';

interface MailingAddressFieldsProps {
    onStateChange?: (state: string) => void;
    fieldPrefix?: string;
}
export const MailingAddressFields = ({
    onStateChange,
    fieldPrefix = '',
}: MailingAddressFieldsProps) => {
    return (
        <Fieldset>
            <TextField
                label="Address Line 1"
                name={[fieldPrefix, 'address.street'].join('.')}
                required
            />
            <TextField label="Address Line 2" name={[fieldPrefix, 'address.address2'].join('.')} />
            <Flex
                gap="4"
                direction="column"
                sm={{ direction: 'row' }}
                style={{ width: '100%', gridColumn: '1 / -1' }}
            >
                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                    <TextField
                        label="City"
                        name={[fieldPrefix, 'address.city'].join('.')}
                        required
                    />
                </div>
                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                    <StateSelectField
                        label="State"
                        name={[fieldPrefix, 'address.state'].join('.')}
                        style={{ width: '100%' }}
                        onChange={onStateChange}
                        required
                    />
                </div>
                <div style={{ flex: '1 1 0', minWidth: 0 }}>
                    <TextField
                        label="Zip Code"
                        name={[fieldPrefix, 'address.zip'].join('.')}
                        required
                        style={{ width: '100%' }}
                        inputMode="numeric"
                    />
                </div>
            </Flex>
        </Fieldset>
    );
};
